export default {
  header: {
    signIn: 'Entrar',
    signUp: 'Cadastrar'
  },
  userMenu: {
    wallet: 'Carteira',
    withdraw: 'Sacar',
    transaction: 'Transação',
    myBet: 'Minhas Apostas',
    rollover: 'Rollover',
    vault: 'Cofre',
    profile: 'Perfil',
    settings: 'Configurações',
    signOut: 'Sair',
    signOutTitle: 'Sair',
    signOutContent: 'Explore um mundo repleto de recompensas e jogos emocionantes!',
    signOutConfirm: 'Sair',
    cancel: 'Cancelar'
  }
};
